<template>
  <TopNav></TopNav>
  <h1>Fractions Calculator</h1>
  <fieldset>
    <legend>Fractions Calculator</legend>
    <div class="div-table">
      <div class="div-table-row">
        <div class="div-table-col">1<sup>st</sup> Fraction</div>
        <div  class="div-table-col">Operation</div>
        <div  class="div-table-col">2<sup>nd</sup> Fraction</div>
      </div>
      <div class="div-table-row">
        <div class="div-table-col"><input type="number" v-model.number="fraction11"></div>
        <div class="div-table-col">&nbsp;</div>
        <div class="div-table-col"><input type="number" v-model.number="fraction21"></div>
      </div>
      <div class="div-table-row">
        <div class="div-table-col">────</div>
        <div class="div-table-col">+</div>
        <div class="div-table-col">────</div>
      </div>
      <div class="div-table-row">
        <div class="div-table-col"><input type="number" v-model.number="fraction12"></div>
        <div class="div-table-col">&nbsp;</div>
        <div class="div-table-col"><input type="number" v-model.number="fraction22"></div>
      </div>
    </div>
    <br>
      Result: <span class="blue">{{ result.result1 }} / {{ result.result2 }}</span>
  </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "Fractions",
  data() {
    return {
      formatter: new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 5
      }),
      fraction11: 1,
      fraction12: 1,
      fraction21: 1,
      fraction22: 1
    }
  },
  components: {
    TopNav
  },
  computed: {
    result: function () {
      let fraction1 = {
        "numerator1": this.fraction11 * this.fraction22,
        "denominator1": this.fraction12 * this.fraction22
      };

      let fraction2 = {
        "numerator2": this.fraction21 * this.fraction12,
        "denominator2": this.fraction22 * this.fraction12
      };

      let sumFractions = fraction1.numerator1 + fraction2.numerator2;

      let commonDenominator = this.fraction12 * this.fraction22;

      let gcd = this.gcdTwoNumbers(sumFractions, commonDenominator);

      let sumFractionsResult = sumFractions / gcd;
      let commonDenominatorResult = commonDenominator / gcd;

      let sumFractionsResultFormatted = this.formatter.format(sumFractionsResult);
      let commonDenominatorResultFormatted = this.formatter.format(commonDenominatorResult);

      return {
        "result1": sumFractionsResultFormatted,
        "result2": commonDenominatorResultFormatted
      }
    },
  },
  methods: {
    gcdTwoNumbers: function (x, y) {
      if ((typeof x !== 'number') || (typeof y !== 'number'))
        return false;
      x = Math.abs(x);
      y = Math.abs(y);
      while (y) {
        let t = y;
        y = x % y;
        x = t;
      }
      return x;
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

footer section a {
  margin: 20px;
}

.div-table {
  display: table;
  width: auto;
  /* background-color: #eee; */
  /* border: 1px solid #666666; */
  /* border-spacing: 5px; */ /* cellspacing:poor IE support for  this */
  text-align: center;
}
.div-table-row {
  display: table-row;
  width: auto;
  clear: both;
  /* border: 1px solid #666666; */
}
.div-table-col {
  float: left; /* fix for  buggy browsers */
  display: table-column;
  width: 110px;
  /* border: 1px solid #666666; */
  /* background-color: #ccc; */
}

input {
  width: 80px;
  text-align: center;
}

.blue {
    color: blue;
}
</style>
